import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Tooltip, Legend, ResponsiveContainer } from 'recharts';

import { instance } from '../../services/api';

interface IChartProps {
  textColor: string;
  chartName: string;
  endpoint: string;
}

interface IData {
  time: number;
  value: number;
  name: string;
  formattedTime: string;
}

const PiePanel: React.FC<IChartProps> = ({
  textColor,
  chartName,
  endpoint,
}) => {
  const [data, setData] = useState<IData[]>([]);
  const [callback, setCallback] = useState(false);

  useEffect(() => {
    instance.get(endpoint).then((res) => {
      const values: IData[] = [];
      const len = res.data.length;

      for (let i = 0; i < 10; i++) {
        try {
          const value =
            len - i - 1 >= 0
              ? res.data[len - i - 1].result
              : res.data[0].result;
          values.push({
            value,
            name: i.toString(),
            time: new Date().getTime() + i * 1000,
            formattedTime: '',
          });
        } catch {
          // we must fix this
        }
      }
      setData(values);
      setTimeout(() => setCallback(!callback), 7000);
    });
  }, [chartName, callback, endpoint]);

  return (
    <>
      <ResponsiveContainer width="99%" height={300}>
        <PieChart
          width={200}
          height={200}
          margin={{
            top: 5,
            right: 30,
            bottom: 5,
          }}
        >
          <Tooltip />
          <Legend />

          <Pie
            dataKey="value"
            isAnimationActive={false}
            data={data}
            cx={150}
            cy={150}
            outerRadius={80}
            fill={textColor}
            label
          />
        </PieChart>
      </ResponsiveContainer>
      <strong style={{ color: 'gray ', marginLeft: '25px' }}>
        {chartName}
      </strong>
    </>
  );
};

export default PiePanel;
